import {
  AppBar,
  Toolbar,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import logo from '../../assets/images/logo--white.svg';

const useStyles = makeStyles(() => ({
  root: {
    boxShadow: 'none'
  },
  flexGrow: {
    flexGrow: 1
  },
}));

function Topbar({ className, ...rest }) {
  const classes = useStyles();

  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
      color="secondary"
    >
      <Toolbar>
        <RouterLink to="/" data-tour="ArtemisButton" style={{ position: 'relative' }}>
          <img alt="Logo" src={logo} />
          <Typography variant="subtitle2" style={{
            position: 'absolute',
            bottom: 0,
            left: '50%',
            transform: 'translateX(-20%)',
            fontSize: '11px',
            backgroundColor: 'rgba(0, 0, 0, 0',
            color: '#FF9800',
            padding: '4px 8px',
            borderRadius: '4px',
          }}>
            <b style={{ fontSize: '10px' }}>v.{process.env.REACT_APP_VERSION}</b>
          </Typography>
        </RouterLink>
      </Toolbar>
    </AppBar>
  );
}

Topbar.propTypes = {
  className: PropTypes.string
};

export default Topbar;
